/* Custom review badge — optional live auto-update.
   Only runs when a badge has data-vfs-reviews-feed: a CORS-enabled JSON endpoint that
   returns the shop's rating + review count. It refreshes the server-rendered numbers and
   swallows any error, so the curated numbers always remain. With no feed configured the
   badge is simply a server-rendered link and this script does nothing.

   The feed is WebwinkelKeur's own ratings_summary endpoint called with the shop's PUBLIC
   API key (made for client-side use; read-only, safe to disclose) — CORS is open and the
   response is cached 4h by the browser via its Cache-Control:
     https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=1212761&public_code=...
   Its shape ({ data: { rating_average, amount } }) is handled below, along with generic
   { rating, count } feeds. */
(function () {
  var badges = document.querySelectorAll('[data-vfs-reviews][data-vfs-reviews-feed]');
  if (!badges.length) return;

  function num(v) { return parseFloat(String(v == null ? '' : v).replace(',', '.')); }
  function group(n) { return ('' + n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function pick(obj, keys) {
    for (var i = 0; i < keys.length; i++) {
      var path = keys[i].split('.'), cur = obj, ok = true;
      for (var j = 0; j < path.length; j++) {
        if (cur != null && typeof cur === 'object' && path[j] in cur) cur = cur[path[j]];
        else { ok = false; break; }
      }
      if (ok && cur != null && cur !== '') return cur;
    }
    return null;
  }

  function apply(el, rating, count) {
    var rn = num(rating);
    if (!isNaN(rn) && rn > 0 && rn <= 10) {
      var score = el.querySelector('[data-vfs-reviews-score]');
      if (score) score.textContent = (Math.round(rn * 10) / 10).toFixed(1).replace('.', ',');
      el.style.setProperty('--vfs-rev-pct', Math.max(0, Math.min(100, Math.round(rn * 10))) + '%');
    }
    if (count != null) {
      var cn = parseInt(String(count).replace(/[^\d]/g, ''), 10);
      if (cn > 0) {
        var c = el.querySelector('[data-vfs-reviews-count]');
        if (c) c.textContent = group(cn);
      }
    }
  }

  Array.prototype.forEach.call(badges, function (el) {
    fetch(el.getAttribute('data-vfs-reviews-feed'), { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        apply(
          el,
          pick(d, ['rating', 'averageRating', 'average', 'score', 'rating_average', 'data.rating', 'data.rating_average', 'ratings.average']),
          pick(d, ['numberOfRatings', 'amount', 'count', 'reviews', 'total', 'data.count', 'data.amount', 'ratings.count'])
        );
      })
      .catch(function () { /* keep the server-rendered numbers */ });
  });
})();
